<template>
  <div id="model-tree" class="w-full h-full">
    <div>
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          class=""
          @click="filterModelTree(0, true, filterTreeKeyWords, 0)"
        ></el-button>
        <!-- <el-button
          slot="append"
          icon="el-icon-arrow-up"
          @click="filterModelTree(modelTreeProp.currentNodeItem, false, filterTreeKeyWords, 0)"
        ></el-button>-->
      </el-input>
    </div>
    <div class="w-full h-[calc(100%-40px)]" v-loading="!modelTreeProp.modelTreeLoadEnd">
      <el-tree
        class="modelTree bg-transparent overflow-auto h-full common-tree"
        v-if="modelTreeVisbile && modelTreeProp.modelTreeLoadEnd"
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :filter-node-method="filterNode"
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="node"
      ></el-tree>
    </div>
  </div>
</template>

<script>
import { ActivityVisualApi } from '@wiz-api/haiguang'
import setModelVisible from '../../assets/js/model/modelTree'
import HandoverService from '../../service/HandoverService'

const activityVisual = new ActivityVisualApi()

export default {
  name: 'ModelTree',
  props: {
    player: {
      type: Object,
      default: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {
          modelTreeProp: {
            currentNodeItem: 0, // 当前激活的node
            currentNodeName: '', // 点选时当前激活的节点名称
            treeData: [], // 模型树数据
            defaultCheckedKey: [], // 模型树选中的节点
            filterItem: [], // 模型树不需要显示的节点及他的父节点列表
            modelHideList: [], // 模型隐藏队列
            modelTreeLoadEnd: false, // 模型树数据加载完毕
            spaceSwapStatus: false, // 交换空间状态
          },
        }
      },
    },
    loadModelStatus: {
      type: Boolean,
      default: false,
    },
    sourceId: {
      type: String,
      defalut: '',
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        }
      },
    },
    // 模型点选的节点node
    modelNode: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    modelNode: {
      async handler(node) {
        const nodeItem = await this.player.Native.Node.getProperty(node.node, ['name'])
        console.log('modelNode change', nodeItem)

        if (nodeItem?.name) {
          if (!nodeItem.name.toLowerCase().startsWith('Unspecified'.toLowerCase())) {
            this.currentNodeName = nodeItem.name
            this.filterModelTree(0, true, nodeItem.name, 3)
          }
        }
      },
      immediate: true,
    },
    'customProps.modelTreeProp.currentNodeName': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
    'customProps.modelTreeProp.defaultCheckedKey': {
      deep: true,
      handler(val, oldVal) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      },
    },
    'customProps.loadModelStatus': {
      immediate: true,
      async handler(val) {
        if (val) {
          this.getModelTreeDatas()
        }
      },
    },
  },
  mounted() {
    this.getStandardList()
    if (this.modelTreeProp.currentNodeName) {
      // 页面初始化时不定位模型
      this.filterModelTree(0, true, this.modelTreeProp.currentNodeName, 0, false)
    }
  },
  async  beforeDestroy() {
    const selectNodes = await this.player.Native.Node.getSeletedNodes()
    await this.player.Native.Node.unSelectNodes(selectNodes)
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
    }
  },
  methods: {
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardId = res.data[0].id
      } else {
        this.standardId = ''
      }
    },
    // 模型树点击操作
    async clickModelTree(data, node, doLocation) {
      if (data.isVirtual) {
        return
      }
      if (node && node.checked && doLocation) {
        this.$emit('doLocation', data, 'modelTree')
        this.multipleLocations(this.player, data)
        // 判断是否勾选任务信息标签再选择是否弹窗任务信息的弹窗
        if (
          this.labelList.find((val) => {
            return val.code === 'TaskInfo'
          }) &&
          this.labelList.find((val) => {
            return val.code === 'TaskInfo'
          }).checked
        ) {
          this.getVisualData(this.sourceId, data.code)
        }
        this.modelTreeProp.currentNodeItem = data && data.node ? data.node : 0 // 储存选中节点的item
      }
      this.locationNode(data.node)
      const [err, res] = await HandoverService.getInfo({
        code: data.code,
        standardId: this.standardId,
      })
      if (!err) {
        this.$emit('transferEvent', {
          toCom: { code: 'ObjectInfoDyw', origin: 'HandoverObjectDyw', name: '对象信息' },
          type: 'business',
          props: data.code
            ? {
              ...res.data[0],
              standardId: this.standardId,
              openAlarmFlicker: true,
              flickerFrequency: 500,
            }
            : {
              standardId: this.standardId,
              openAlarmFlicker: true,
              flickerFrequency: 500,
              code: data.code,
            },
        })
      }
    },
    async multipleLocations(player, data, isSelect = true, isLoadEngine) {
      // 高亮选中的模型
      if (isSelect) {
        const selectNodes = await this.player.Native.Node.getSeletedNodes()
        await this.player.Native.Node.unSelectNodes(selectNodes)
        this.player.Native.Node.selectNodes([data.node])
      }
      this.player.Native.Camera.moveToNode(data.node, 2, 5)
    },
    // 获取项目计划可视化数据
    async getVisualData(sceneId, tagCode) {
      const [err, res] = await activityVisual.getActivityVisual({
        tenantId:
          localStorage.getItem('CurrentTenantId') ||
          JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
          '8b53295c-b059-4caf-8fc6-4a1d9e7807e9',
        sceneId,
        tagCode,
      })
      // console.log(res, '获取项目计划可视化数据')
      if (!err) {
        if (!res.length) {
          this.$message.warning('该模型未配置关联任务')
        }
        const openEvent = new CustomEvent('openComponent', {
          detail: {
            toCom: { code: 'TaskInfo', origin: 'tag', originTagName: 'TaskInfo', name: '任务详情' },
            type: 'tags',
            props: {
              taskRow: res,
            },
          },
        })
        window.dispatchEvent(openEvent)
      }
    },
    // 模型树加载
    async loadNode(node, resolve) {
      console.log('懒加载', node)
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.node
        })
        return resolve(this.modelTreeProp.treeData)
      }
      let res = []
      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        res = result?.children || []
      }
      if (res.length > 1000) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / 1000); i += 1) {
          shardingRes.push({
            name: `${i * 1000 + 1}~${(i + 1) * 1000}`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * 1000, (i + 1) * 1000),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.node
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.name
        }),
        (res5) => {
          return res5.node
        }
      )
      // 查看当前节点是否没有在隐藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.node
            }),
            nodeObj.data.node
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在隐藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在隐藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在隐藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在隐藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.node
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.node) {
          if (el.node === this.currentNode.node) {
            this.locationNode(this.currentNode.node)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('modelTree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          node.scrollTo({
            top: currentNode.offsetTop,
          })
        }, 600)
      })
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.node)
      if (data.isVirtual) {
        this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
        return
      }
      setModelVisible(
        this.player,
        'checkModelTree',
        isChecked,
        [data.node],
        this.modelTreeProp,
        checkeds
      )
    },
    async filterModelTree(startNode, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      // #######################
      const res = await this.player.Native.Node.findNode(startNode, {
        names: [KeyWords],
        codes: [KeyWords],
      })
      this.currentNode = res.codes
        ? res.codes[KeyWords] || {}
        : res.names
          ? res.names[KeyWords] || {}
          : {}
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message({
          showClose: true,
          message: '搜索结果到底了',
          type: 'error',
        })
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          console.log('到达根节点，做定位')
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: true }, doLocation)
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        console.log('defaultExpandedKeys', this.defaultExpandedKeys, parentInfo.code)
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (!_.isNil(expandIndex) && expandIndex > -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      console.log('this.modelTreeProp.treeData', this.modelTreeProp.treeData)

      this.modelTreeProp.modelTreeLoadEnd = true
    },
  },
}
</script>

<style lang="scss" scoped>
#model-tree {
  background-color: transparent;
}

::v-deep .modelTree > .el-tree-node[tabindex='0'] {
  display: inline-block;
}
::v-deep .el-loading-mask {
  height: calc(100% - 42px);
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
